import { ajax } from '../ajax'


//、 授课-课中预习任务列表
export const reqSKTaskList = (paramets) => ajax(`/jxtask/jxTask/getTaskPageList`, paramets)
//、 教学预习任务-通过id查询预习详情
export const reqTaskDetails = (paramets) => ajax(`/jxtask/jxTask/getTaskDetails`, paramets)
//、 教学预习任务-获取预习测验详情
export const reqTestListDetail = (paramets) => ajax(`/jxtask/jxTask/getTestList`, paramets)
//、任务学生留言-分页列表查询
export const reqStuRootMessage = (paramets) => ajax(`/jxtask/jxTaskStuMessage/getMessageList`, paramets)



// WEBPACK FOOTER //
// ./src/api/give-course/yxTask.js